import script from "./promotionType.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionType.vue?vue&type=script&lang=ts&setup=true"

import "./promotionType.vue?vue&type=style&index=0&id=7375fdf2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7375fdf2"]])

export default __exports__